import { Box, Stack } from '@mui/material';
import FileExplorer from 'components/FileExplorer';
import { UploadStateDebug } from 'components/FileExplorer/UploadStateDebug';
import React from 'react';

/**
 * File-thingy page: FileExplorer plus raw upload state debug view.
 */
export default function FileThingPage() {
  return (
    <Box sx={{ p: 2 }}>
      <Stack>
        <FileExplorer />
        <UploadStateDebug />
      </Stack>
    </Box>
  );
}
